// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__I2SZd","disabled":"styles_disabled__Fxpl6","content":"styles_content__Xt1B8","text":"styles_text__yDLkI"};